import React, { useEffect, useState } from "react";
import "./BusinessSettings.css";
import { duplicateDetectionApi, duplicateDetectionApistatus } from "../../Services/DuplicateService/DuplicateApi";
import AlertMessage from "../../Components/AlertMessage/AlertMessage";
import { useSelector } from "react-redux";

type SettingsSection = "duplicateItems" | null;

const BusinessSettings: React.FC = () => {
  const [selectedSection, setSelectedSection] =
    useState<SettingsSection>("duplicateItems");
    
const [duplicateDetectionEnabled, setDuplicateDetectionEnabled] =
  useState<boolean | null>(null);

  const [Client, setClient] = useState<any>(null);
  const selectedClient = useSelector((state: any) => state.selectedClient);
  const handleSectionChange = (section: SettingsSection) => {
    setSelectedSection(section);
  };
const handleDuplicateToggle = async () => {
  const newState = !duplicateDetectionEnabled;
    if (!Client) {
    AlertMessage({
      type: "warning",
      text: "Please select the client",
    });
    return;
  }

  try {
    await duplicateDetectionApi({
      clientId: Client,
      isEnabled: newState,
    });

    // Update UI only after API success
    setDuplicateDetectionEnabled(newState);

    AlertMessage({
      type: "success",
      text: newState
        ? "Duplicate Detection Activated"
        : "Duplicate Detection Deactivated",
    });
  } catch (error) {
    console.error("Duplicate detection update failed:", error);
  }
};
 useEffect(() => {
  const clientId = localStorage.getItem("client");
  const parsedClientData = JSON.parse(clientId || "{}");
  const currentClientId = parsedClientData.clientId;

  setClient(currentClientId);

  const fetchDuplicateStatus = async () => {
    if (!currentClientId) return;

    try {
      const response = await duplicateDetectionApistatus(
        String(currentClientId)
      );
      console.log("response",response.data.isEnabled)

      // API response value directly set to toggle state
      setDuplicateDetectionEnabled(
        response.data.isEnabled === true || response.data.isEnabled === "true"
      );
    } catch (error) {
      console.error("Failed to fetch duplicate detection status:", error);
    }
  };

  fetchDuplicateStatus();
}, []);

 if (!selectedClient?.selectedClient?.userId) {
    return (
      <h1>Please select a client to view their invoices getting processed.</h1>
    );
  }
  return (
    <div className="business-settings">
      {/* Left Sidebar */}
      <aside className="business-settings-sidebar">
        <div className="settings-title">Settings</div>
        
        <button
          type="button"
          className={`duplicate-items-btn ${
            selectedSection === "duplicateItems" ? "selected" : ""
          }`}
          onClick={() => handleSectionChange("duplicateItems")}
        >
          Duplicate Items
        </button>
      </aside>

      {/* Main Content */}
      <main className="business-settings-content">
        {selectedSection === "duplicateItems" && (
          <div className="duplicate-card">
            {/* Duplicate Detection Information */}
            <div className="duplicate-card-left">
              <div className="warning-icon">
                <span>!</span>
              </div>

              <div className="duplicate-text">
                <h2>Duplicate Detection</h2>

                <p>
                  Automatically detect and flag potential duplicate invoices
                  in
                  <br />
                  the invoice list
                </p>
              </div>
            </div>

            {/* Toggle */}
            <div className="toggle-wrapper">
              <button
                type="button"
                className={`toggle ${duplicateDetectionEnabled === true ? "active" : ""
                  }`}
                onClick={handleDuplicateToggle}
                aria-pressed={duplicateDetectionEnabled === true}
                aria-label="Toggle duplicate detection"
              >
                <span className="toggle-circle" />
              </button>

              <span className="toggle-label">
                {duplicateDetectionEnabled ? "Enabled" : "Disabled"}
              </span>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default BusinessSettings;